import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 THE 360 SPINAL SHIELD™',
  ideal: 'Anyone wishing to manage spinal health and back pain from scratch',
  was: 'USD 38',
  now: '19',
  features: ['6 Complete Volumes (Spine Focus)', 'Step-by-step visual protocols', '30-Day recovery roadmap', '5 Free Spinal-Specific Bonuses', '7-Day Money-Back Guarantee', '♾️ Lifetime access & free updates'],
  cta: 'Get The 360 SPINAL SHIELD™ System'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full scroll-mt-20 overflow-x-hidden" data-id="element-118" data-mp="3c7iaehaccl3p">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-119" data-mp="3vyxdgh76ounh">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(193,18,31,0.45)]" style={{
        paddingTop: "5px",
        paddingBottom: "5px"
      }} data-id="element-120" data-mp="9s8t54h7ns9p">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-121" data-mp="3rywuqkd1xxam">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-122" data-mp="2uj99tbrsubqv">
            <span className="font-semibold text-plum/80" data-id="element-123" data-mp="2ugd9xhwe5czs">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-124" data-mp="2zfg4u9inq2u1">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "20px"
          }} data-id="element-125" data-mp="2rgcvfu4vgbuq">{plan.was}</span>
            <div className="flex w-full justify-center" style={{
            paddingTop: "9px",
            paddingBottom: "9px"
          }} data-id="element-126" data-mp="2mh8koz2au62a">
              <span className="relative inline-block font-display leading-none" style={{
              fontFamily: "Montserrat, sans-serif"
            }} data-id="element-127" data-mp="2w7uxklimsiha">
                {/* Currency symbol — adjust fontSize here */}
                <span className="text-grape-shine absolute right-full top-1/2 -translate-y-1/2 font-black leading-none" style={{
                fontSize: "45px",
                marginRight: "4px",
                fontFamily: "Merriweather, serif"
              }} data-id="element-128" data-mp="23jpd7zvhovhz">
                  $
                </span>

                {/* Amount — stays centered on the page */}
                <span className="text-grape-shine font-black leading-none" style={{
                fontSize: "74px",
                fontFamily: "Merriweather, serif"
              }} data-id="element-129" data-mp="3tuag7qmsnm6f">
                  {plan.now}
                </span>

                {/* Currency code — adjust fontSize here */}
                <span className="absolute left-full top-1/2 -translate-y-1/2 font-bold uppercase leading-none tracking-wide text-grape" style={{
                fontSize: "26px",
                marginLeft: "6px",
                fontWeight: "900",
                fontFamily: "Merriweather, serif"
              }} data-id="element-130" data-mp="cq8dj3osw3g">
                  USD
                </span>
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-131" data-mp="j37s4y6jkhco">
              · One-time payment ·
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" style={{
            color: "#C1121F"
          }} data-id="element-132" data-mp="a8t9qmqpsqpc">
              Payment will be processed in your local currency.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-133" data-mp="11zzhnpcofsp6">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-134" data-mp="16qfvhaketgc2">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-135" data-mp="16sahks7f3ehq" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-136" data-mp="3a85vrhizifit">
            <CTAButton size="md" data-id="element-137" data-mp="359cjttjciwkr">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" style={{
          color: "#050505"
        }} data-id="element-138" data-mp="359mc5nrv5ftm">
            You save $148 USD (88% OFF · Just for today - Launch Price)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-139" data-mp="1rubzm3kppkc">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-140" data-mp="3o6dr5l0dh8rv">
                <Icon className="h-4 w-4 text-grape" data-id="element-141" data-mp="3k5tu0hfsu55q" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-142" data-mp="kl81hboip3sk" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-143" data-mp="fsn8udhckwqm">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-144" data-mp="1ygptvxq6duva" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-145" data-mp="23dgbiphmoyit">
            <span className="font-display font-bold text-plum" data-id="element-146" data-mp="27ftej64zqibw">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel the system does not match what you need, request
            your refund and SIGMA SMART™ will return 100% of your money. No risk.
          </p>
        </div>
      </div>
    </section>;
}